/* @flow */

import {onlyNumbers} from '@tectonics/prs/normalize';
import {handleError} from '@tectonics/alert-handler';

const DNI_PATTERN = /^\d{7,8}$/;
const CUIL_CUIT_PATTERN = /^\d{10,11}$/;

const CUIL_PREFIXES = ['20', '23', '24', '25', '26', '27'];
const CUIT_PREFIXES = ['30', '33', '34'];

export function decideArgentineDocument(doc: string): string {
  if (!doc) {
    return '';
  }

  const docNormalized = onlyNumbers(doc);

  if (DNI_PATTERN.test(docNormalized)) {
    return 'DNI';
  }

  if (CUIL_CUIT_PATTERN.test(docNormalized)) {
    const prefix = docNormalized.slice(0, 2);
    if (CUIL_PREFIXES.includes(prefix)) {
      return 'CUIL';
    }
    if (CUIT_PREFIXES.includes(prefix)) {
      return 'CUIT';
    }

    return 'CDI';
  }

  handleError(new Error(`Could not identify AR document type: ${doc}`));

  return 'DNI';
}
